__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hcm/shared-rbac", "1.0.0", () => (Promise.all([__webpack_require__.e(50), __webpack_require__.e(431)]).then(() => (() => (__webpack_require__(431))))));
			register("@hcm/shared-store", "1.0.0", () => (Promise.all([__webpack_require__.e(908), __webpack_require__.e(50), __webpack_require__.e(610), __webpack_require__.e(123)]).then(() => (() => (__webpack_require__(7123))))));
			register("@hcm/shared-types", "1.0.0", () => (__webpack_require__.e(995).then(() => (() => (__webpack_require__(3995))))));
			register("@hcm/shared-ui", "1.0.0", () => (Promise.all([__webpack_require__.e(50), __webpack_require__.e(306), __webpack_require__.e(610), __webpack_require__.e(730), __webpack_require__.e(340)]).then(() => (() => (__webpack_require__(7935))))));
			register("@hcm/shared-utils", "1.0.0", () => (Promise.all([__webpack_require__.e(705), __webpack_require__.e(50), __webpack_require__.e(26), __webpack_require__.e(681)]).then(() => (() => (__webpack_require__(3681))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(50)]).then(() => (() => (__webpack_require__(316))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(179), __webpack_require__.e(50), __webpack_require__.e(306)]).then(() => (() => (__webpack_require__(2179))))));
			register("react", "18.3.1", () => (__webpack_require__.e(155).then(() => (() => (__webpack_require__(2155))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};